<template>
  <v-alert
    v-if="hasErrors"
    type="error"
    prominent
  >
    <h3>Error</h3>
    <p>Please correct the following error(s):</p>
    <ul>
      <base-multi-error-extractor
        v-bind="$attrs"
        style="margin-top: 1rem; "
      >
        <template slot-scope="{ errorMessage }">
          <li class="form-error is-visible">
            {{ errorMessage }}
          </li>
        </template>
      </base-multi-error-extractor>
    </ul>
  </v-alert>
</template>

<script>
import { templates, multiErrorExtractorMixin } from 'vuelidate-error-extractor'

export default {
  components: {
    baseMultiErrorExtractor:
      templates.multiErrorExtractor.baseMultiErrorExtractor
  },
  mixins: [multiErrorExtractorMixin],
  inheritAttrs: false
}
</script>
